import React, {useRef} from "react";
import ReactToPrint from "react-to-print";
import {Link} from "react-router-dom";
import ComponentToPrintStation from "./componentToPrintStation";
import {useUser} from "../../Services/userProvider";

export default function PrinterStation({ data, critere, type, endAt, startAt, param, devise}) {
    let componentRef = useRef();
    const user = useUser();


    return (
        <>
            <div>
                {/* button to trigger printing of target component */}
                <ReactToPrint
                    trigger={() => <Link className="btn btn-sm btn-success mt-3" to="#">
                        Imprimer <i className="bi bi-printer"></i>
                    </Link>}
                    content={() => componentRef}
                />

                {/* component to be printed */}
                <div style={{ display: "none" }}>
                    <ComponentToPrintStation
                        param={param}
                        type={type}
                        endAt={endAt}
                        devise={devise}
                        startAt={startAt}
                        critere={critere}
                        data={data} ref={(el) => (componentRef = el)} />
                </div>
            </div>
        </>
    );
}